import React from 'react';
import { useTranslation } from 'react-i18next';
import DialogContent from '@material-ui/core/DialogContent';

import Modal from '../../../_ui/Modal/Modal';
import {
  StyledModalContainer,
  TableWrapper
} from '../ServiceProvidersModal/ServiceProvidersModalStyles';
import ParentOrganizationsTable from './ParentOrganizationsTable';
import { changeFormValue } from '../../../passport/Passport';

function ParentOrganizationsModal({ modal }) {
  const { data, close } = modal;
  const { t } = useTranslation();

  const onClickRow = ({ original }) => {
    changeFormValue('request_form_service_provider_short.Parent_organization', original.id);
    changeFormValue('request_form_service_provider_short.Parent_organization_1', original.bin);
    modal.close();
  };

  return (
    <Modal
      open
      maxWidth="lg"
      title={t('serviceProviders_title')}
      onClose={close}
      scroll="paper"
    >
      <DialogContent dividers>
        <div className="overflow-auto">
          <StyledModalContainer>
            <TableWrapper>
              <ParentOrganizationsTable index={2} onClickRow={onClickRow} />
            </TableWrapper>
          </StyledModalContainer>
        </div>
      </DialogContent>
    </Modal>
  );
}

export default ParentOrganizationsModal;
